/* eslint-disable */
// source: vivacity/core/red_light_state_change.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var vivacity_core_classifying_detector_class_types_pb = require('../../vivacity/core/classifying_detector_class_types_pb.js');
goog.object.extend(proto, vivacity_core_classifying_detector_class_types_pb);
var vivacity_core_detection_box_pb = require('../../vivacity/core/detection_box_pb.js');
goog.object.extend(proto, vivacity_core_detection_box_pb);
goog.exportSymbol('proto.vivacity.core.RedLightStateChange', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.RedLightStateChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.vivacity.core.RedLightStateChange.repeatedFields_, null);
};
goog.inherits(proto.vivacity.core.RedLightStateChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.RedLightStateChange.displayName = 'proto.vivacity.core.RedLightStateChange';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.vivacity.core.RedLightStateChange.repeatedFields_ = [8];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.RedLightStateChange.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.RedLightStateChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.RedLightStateChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.RedLightStateChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    visionProgramId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    roi: (f = msg.getRoi()) && vivacity_core_detection_box_pb.ROIBox.toObject(includeInstance, f),
    previousState: jspb.Message.getFieldWithDefault(msg, 3, 0),
    newState: jspb.Message.getFieldWithDefault(msg, 4, 0),
    transitionTimestampMicroseconds: jspb.Message.getFieldWithDefault(msg, 5, 0),
    medianConfidence: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    confidencesList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 8)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.RedLightStateChange}
 */
proto.vivacity.core.RedLightStateChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.RedLightStateChange;
  return proto.vivacity.core.RedLightStateChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.RedLightStateChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.RedLightStateChange}
 */
proto.vivacity.core.RedLightStateChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setVisionProgramId(value);
      break;
    case 2:
      var value = new vivacity_core_detection_box_pb.ROIBox;
      reader.readMessage(value,vivacity_core_detection_box_pb.ROIBox.deserializeBinaryFromReader);
      msg.setRoi(value);
      break;
    case 3:
      var value = /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (reader.readEnum());
      msg.setPreviousState(value);
      break;
    case 4:
      var value = /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (reader.readEnum());
      msg.setNewState(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTransitionTimestampMicroseconds(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setMedianConfidence(value);
      break;
    case 8:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedFloat() : [reader.readFloat()]);
      for (var i = 0; i < values.length; i++) {
        msg.addConfidences(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.RedLightStateChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.RedLightStateChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.RedLightStateChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.RedLightStateChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVisionProgramId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getRoi();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      vivacity_core_detection_box_pb.ROIBox.serializeBinaryToWriter
    );
  }
  f = message.getPreviousState();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getNewState();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getTransitionTimestampMicroseconds();
  if (f !== 0) {
    writer.writeUint64(
      5,
      f
    );
  }
  f = message.getMedianConfidence();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getConfidencesList();
  if (f.length > 0) {
    writer.writePackedFloat(
      8,
      f
    );
  }
};


/**
 * optional uint32 vision_program_id = 1;
 * @return {number}
 */
proto.vivacity.core.RedLightStateChange.prototype.getVisionProgramId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
 */
proto.vivacity.core.RedLightStateChange.prototype.setVisionProgramId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional ROIBox roi = 2;
 * @return {?proto.vivacity.core.ROIBox}
 */
proto.vivacity.core.RedLightStateChange.prototype.getRoi = function() {
  return /** @type{?proto.vivacity.core.ROIBox} */ (
    jspb.Message.getWrapperField(this, vivacity_core_detection_box_pb.ROIBox, 2));
};


/**
 * @param {?proto.vivacity.core.ROIBox|undefined} value
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
*/
proto.vivacity.core.RedLightStateChange.prototype.setRoi = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
 */
proto.vivacity.core.RedLightStateChange.prototype.clearRoi = function() {
  return this.setRoi(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.vivacity.core.RedLightStateChange.prototype.hasRoi = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional ClassifyingDetectorClassTypes previous_state = 3;
 * @return {!proto.vivacity.core.ClassifyingDetectorClassTypes}
 */
proto.vivacity.core.RedLightStateChange.prototype.getPreviousState = function() {
  return /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.vivacity.core.ClassifyingDetectorClassTypes} value
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
 */
proto.vivacity.core.RedLightStateChange.prototype.setPreviousState = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional ClassifyingDetectorClassTypes new_state = 4;
 * @return {!proto.vivacity.core.ClassifyingDetectorClassTypes}
 */
proto.vivacity.core.RedLightStateChange.prototype.getNewState = function() {
  return /** @type {!proto.vivacity.core.ClassifyingDetectorClassTypes} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.vivacity.core.ClassifyingDetectorClassTypes} value
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
 */
proto.vivacity.core.RedLightStateChange.prototype.setNewState = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional uint64 transition_timestamp_microseconds = 5;
 * @return {number}
 */
proto.vivacity.core.RedLightStateChange.prototype.getTransitionTimestampMicroseconds = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
 */
proto.vivacity.core.RedLightStateChange.prototype.setTransitionTimestampMicroseconds = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional float median_confidence = 7;
 * @return {number}
 */
proto.vivacity.core.RedLightStateChange.prototype.getMedianConfidence = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
 */
proto.vivacity.core.RedLightStateChange.prototype.setMedianConfidence = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * repeated float confidences = 8;
 * @return {!Array<number>}
 */
proto.vivacity.core.RedLightStateChange.prototype.getConfidencesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 8));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
 */
proto.vivacity.core.RedLightStateChange.prototype.setConfidencesList = function(value) {
  return jspb.Message.setField(this, 8, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
 */
proto.vivacity.core.RedLightStateChange.prototype.addConfidences = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 8, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.vivacity.core.RedLightStateChange} returns this
 */
proto.vivacity.core.RedLightStateChange.prototype.clearConfidencesList = function() {
  return this.setConfidencesList([]);
};


goog.object.extend(exports, proto.vivacity.core);
